import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { useUserState } from '../hooks/useUserState';

function Dashboard() {
  const navigate = useNavigate();
  const { tier, usageRemaining } = useUserState();

  return (
    <Layout mode="sidebar" tier={tier} usageRemaining={usageRemaining}>
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', height: '100%' }}>
      <div style={{ padding: '32px 24px', maxWidth: '900px' }}>
        <div style={{ marginBottom: '32px' }}>
          <h1 style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: 'clamp(24px, 4vw, 32px)',
            fontWeight: 700,
            letterSpacing: '-0.02em',
            color: 'var(--text-primary)',
            marginBottom: '6px',
          }}>
            Welcome back
          </h1>
          <p style={{ fontSize: '14px', color: 'var(--text-muted)' }}>
            What would you like to do today?
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', maxWidth: '560px' }}>
          <button
            onClick={() => navigate('/editor')}
            style={{
              padding: '28px 24px',
              border: '1px solid var(--border)',
              borderLeft: '4px solid var(--accent)',
              borderRadius: '12px',
              background: 'linear-gradient(135deg, var(--bg-card) 0%, rgba(0,212,255,0.04) 100%)',
              textAlign: 'left',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              width: '100%',
              boxShadow: '0 4px 24px -4px rgba(0,212,255,0.12)',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = 'rgba(0,212,255,0.35)';
              e.currentTarget.style.borderLeftColor = 'var(--accent)';
              e.currentTarget.style.background = 'var(--accent-bg)';
              e.currentTarget.style.boxShadow = '0 8px 30px -8px rgba(0,212,255,0.2)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = 'var(--border)';
              e.currentTarget.style.borderLeftColor = 'var(--accent)';
              e.currentTarget.style.background = 'linear-gradient(135deg, var(--bg-card) 0%, rgba(0,212,255,0.04) 100%)';
              e.currentTarget.style.boxShadow = '0 4px 24px -4px rgba(0,212,255,0.12)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <p style={{
              fontSize: '16px',
              fontWeight: 600,
              color: 'var(--text-primary)',
              fontFamily: "'Outfit', sans-serif",
              marginBottom: '6px',
            }}>
              New rewrite
            </p>
            <p style={{ fontSize: '13px', color: 'var(--text-muted)', lineHeight: 1.5 }}>
              Transform your draft into polished executive communication
            </p>
          </button>

          <button
            onClick={() => navigate('/coach')}
            style={{
              padding: '24px 24px',
              border: '1px solid var(--border)',
              borderLeft: '3px solid var(--accent)',
              borderRadius: '12px',
              background: 'var(--bg-card)',
              textAlign: 'left',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              width: '100%',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = 'rgba(0,212,255,0.35)';
              e.currentTarget.style.borderLeftColor = 'var(--accent)';
              e.currentTarget.style.background = 'var(--accent-bg)';
              e.currentTarget.style.boxShadow = '0 8px 30px -8px rgba(0,212,255,0.2)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = 'var(--border)';
              e.currentTarget.style.borderLeftColor = 'var(--accent)';
              e.currentTarget.style.background = 'var(--bg-card)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <p style={{
              fontSize: '16px',
              fontWeight: 600,
              color: 'var(--text-primary)',
              fontFamily: "'Outfit', sans-serif",
              marginBottom: '6px',
            }}>
              PM Coach
            </p>
            <p style={{ fontSize: '13px', color: 'var(--text-muted)', lineHeight: 1.5 }}>
              Get instant project management guidance from your AI-powered TPM advisor
            </p>
          </button>
        </div>
      </div>
      </div>
    </Layout>
  );
}

export default Dashboard;
